export type KeyOf<T> = Extract<keyof T, string>;

/**
 * `Object.keys`, but with possibility to use it like any other generic, e.g `Array.map<T>()`.
 */
export const keys = Object.keys as <T extends Record<string, unknown>>(
	yourObject: T
) => Array<KeyOf<T>>;
